import { Validator } from '@vista-digital/validator';
export const defaultOccMemberSubscriptionsConfig = {
    expiringSoonThresholdInMonths: 1,
    showThirdPartyPaymentProviderWarning: true,
    showMemberSubscriptionCardMemberPhotos: true
};
export const occMemberSubscriptionsConfigValidator = Validator.object({
    expiringSoonThresholdInMonths: Validator.number({ min: 1 }),
    showThirdPartyPaymentProviderWarning: Validator.boolean(),
    showMemberSubscriptionCardMemberPhotos: Validator.boolean()
});
//# sourceMappingURL=subscription.js.map